export const changeFocusAfterDialogIsClosed = (id: string) => {
  setTimeout(() => {
    const element = document.getElementById(id);
    element?.focus();
  }, 1);
};
